export const generateRangeOfYears = (startYear: number, endYear: number): number[] => {
   if (endYear < startYear) return [];

   return Array.from({ length: endYear - startYear + 1 }, (__, i) => startYear + i);
};
